import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';

type GetShouldShowCandidateProfileListTabsProps = {
  candidateProfileListProps: CandidateProfileListProps;
};

export const getShouldShowCandidateProfileListTabs = (
  props: GetShouldShowCandidateProfileListTabsProps
): boolean => {
  switch (props.candidateProfileListProps.type) {
    case CandidateProfileListType.CANDIDATES_LIST:
    case CandidateProfileListType.ANALYSIS_CANDIDATES_LIST:
      return true;
    case CandidateProfileListType.CANDIDATES_FROM_TALENT_POOL:
    case CandidateProfileListType.ADD_CANDIDATES_TO_TALENT_POOL:
    case CandidateProfileListType.ANALYSIS_CANDIDATES_FROM_TALENT_POOL:
      return false;
  }
};
